import { defineNuxtPlugin } from '#app'
import {useDefaultStore} from "~/modules/common/stores/default-store";
import { useTenantStore } from "~/modules/common/stores/tenants";
import { useProductStore } from "~/modules/common/stores/products";
import { useSubscriptionStore } from "~/store/subscriptions";

export default defineNuxtPlugin(async (nuxtApp) => {
    console.log('Plugin injected by common-module!')

    await useDefaultStore().initialize(nuxtApp.$config.public.datenbankgestalterCommon.backendUrl);

    await useTenantStore().initialize(nuxtApp.$config.public.datenbankgestalterCommon.tenant);

    await useProductStore().updateProductsFromBackend();

    if (useTenantStore().isMyDb){
        // await useSubscriptionStore().getCurrentUserSubscriptions();
    }
})

